<div class="password-strength-tooltip" *ngIf="show">
  <div class="tooltip-content">
    <div class="strength-section">
      <div class="strength-label">{{ passwordStrength }}</div>
      <div class="strength-bar">
        <div 
          *ngFor="let level of [1,2,3,4]; let i = index" 
          class="strength-segment"
          [class.filled]="i < strengthLevel">
        </div>
      </div>
    </div>
    
    <div class="requirements-section">
      <div class="requirements-title">Your Password must contain:</div>
      <div class="requirement-item" *ngFor="let req of requirements">
        <div class="requirement-icon" [class.met]="req.met">
          <span *ngIf="!req.met">✗</span>
          <span *ngIf="req.met">✓</span>
        </div>
        <span class="requirement-text">{{ req.text }}</span>
      </div>
    </div>
  </div>
</div>
